var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666748 8C0.666748 3.58172 4.24847 0 8.66675 0H16.6667C21.0849 0 24.6667 3.58172 24.6667 8V16C24.6667 20.4183 21.0849 24 16.6667 24H8.66674C4.24846 24 0.666748 20.4183 0.666748 16V8Z",
    fill: "#48DF45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 4C8.25556 4 4.66675 7.58872 4.66675 12C4.66675 16.4112 8.25556 20 12.6667 20C17.0779 20 20.6667 16.4112 20.6667 12C20.6667 7.58872 17.0779 4 12.6667 4ZM17.2604 10.6487L12.2345 15.6747C12.0208 15.8884 11.7367 16.006 11.4345 16.006C11.1323 16.006 10.8482 15.8884 10.6345 15.6747L8.07299 13.1131C7.85929 12.8994 7.74158 12.6154 7.74158 12.3132C7.74158 12.0109 7.85929 11.7268 8.07299 11.5131C8.28661 11.2994 8.57069 11.1817 8.87296 11.1817C9.17515 11.1817 9.45931 11.2994 9.67293 11.5132L11.4344 13.2746L15.6603 9.04867C15.874 8.83497 16.1581 8.71735 16.4603 8.71735C16.7625 8.71735 17.0466 8.83497 17.2603 9.04867C17.7015 9.48994 17.7015 10.2076 17.2604 10.6487Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.5b250b98845f72617be109b638afb475.svg";
export { ForwardRef as ReactComponent };